//Show spinner element
export function showSpinner() {
    $('#spinner').addClass('spinner');
    $('#spinner-content').addClass('spinner-content');
}

//Hide spinner element
export function hideSpinner() {
    $('#spinner').removeClass('spinner');
    $('#spinner-content').removeClass('spinner-content');
}

//Show header spinner element
export function showHeaderSpinner() {
    $('#header-spinner').addClass('header-spinner');
    $('#header-spinner-content').addClass('header-spinner-content');
}

//Hide header spinner element
export function hideHeaderSpinner() {
    $('#header-spinner').removeClass('header-spinner');
    $('#header-spinner-content').removeClass('header-spinner-content');
}

